import TranslationProvider from '@/provider/translations.js'
import { client } from '@/services/fetch.js'
import { toast } from '@/services/toast.js'

import { buildFilterQuery } from '@/libs/utils.js'

const baseURL = '/config/templates/polls/api'

export const pollTemplateStates = {
  active: 'Attivo',
  draft: 'Draft',
  deactivated: 'Disattivato'
}

export const getPollTemplates = async (
  page = 1,
) => {
  try {
    let url = baseURL + `/poll-template?complete=1&page=${page}&orderBy[field]=updatedAt&orderBy[direction]=DESC`

    return await client.get(url)
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}

export const getPollTemplateCampaigns = async (pollTemplateReference, page = 1) => {
  try {
    let url = baseURL + `/campaign?pollTemplateReference=${pollTemplateReference}&page=${page}`
    return await client.get(url)
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}

export const getPollTemplate = async (
  pollTemplateId,
  params = {complete: null, stats:null}
) => {
  try {
    let url = baseURL + `/poll-template/${pollTemplateId}`

    const query = buildFilterQuery(params)
    if (query) {
      url += `?${query}`
    }

    return await client.get(url)
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}

export const getPollTemplateHistory = async (
  pollTemplateId,
  params = { complete: null, stats: null }
) => {
  try {
    let url =  baseURL + `/poll-template/${pollTemplateId}/history`

    const query = buildFilterQuery(params)
    if (query) {
      url += `?${query}`
    }

    return await client.get(url)
  } catch (error) {

  }
}

export const getPollTemplateHistoryByIdAndRevision = async (
  pollTemplateId,
  revisionNumber,
  params = { complete: null, stats: null }
) => {
  try {
    let url =  baseURL + `/poll-template/${pollTemplateId}/history/${revisionNumber}`

    const query = buildFilterQuery(params)
    if (query) {
      url += `?${query}`
    }

    return await client.get(url)
  } catch (error) {

  }
}

export const deletePollTemplateCampaign = async (campaignId) => {
  try {
    let url = baseURL + `/config/templates/polls/api/campaign/${campaignId}`
    const response = await client.delete(url)
    toast.create('Campagna eliminata con successo', 'success')
    return response
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}
